import instance, { customConfig } from "../../../Utils/Interceptors/Interceptor";

const ObtenerPlan = async (values) => {
    try {
        const resultado = await instance.Backend.post("/InformeConservacion/ObtenerPlan",values, customConfig);

        return resultado

    } catch (error) {
        console.log(error);
    }

}
export { ObtenerPlan };
